import { sendGet } from './../helpers/axios';

export const apiListUser = (params) => sendGet('/api/user/list', params);
